import DynamicTable from './Table/index.jsx';

export default DynamicTable;
export { DynamicTable }
